import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-46827ebd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-flex-wrap-reverse p-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-flex-column p-justify-center p-align-center" }, " Le terminal est désormais libre. Vous pouvez vous connecter et travailler. ", -1))
const _hoisted_3 = {
  class: "p-m-0 p-text-center p-text-uppercase p-error",
  style: {"width":"100%"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle p-mr-1" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-flex-column p-justify-center p-align-center" }, " Vous ne pouvez pas effectuer de modifications car un autre utilisateur est actuellement connecté sur ce terminal. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", { freeTerminal: _ctx.freeTerminal }, undefined, true),
    (_ctx.activePrompts)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.activeTerminal.userId)
            ? (_openBlock(), _createBlock(_component_Dialog, {
                key: 0,
                breakpoints: { '960px': '96vw' },
                style: { maxWidth: '400px', 'margin-top': '-5px' },
                position: "center",
                visible: !_ctx.activeTerminal.userId,
                closable: false,
                header: "Terminal libre"
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_Button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.connect(false))),
                    class: "p-button-success",
                    label: _ctx.$t('login')
                  }, null, 8, ["label"]),
                  _createVNode(_component_Button, {
                    onClick: _ctx.activeStayInReadOnlyMode,
                    class: "p-button-warning",
                    label: _ctx.$t('terminal.leave')
                  }, null, 8, ["onClick", "label"])
                ]),
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["visible"]))
            : (!_ctx.freeTerminal && _ctx.activeTerminal.userId !== -1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_Dialog, {
                    position: "right",
                    "show-header": false,
                    visible: !_ctx.maximized,
                    closable: true,
                    "content-style": "border-top-left-radius: 20px; border-top-right-radius: 20px;"
                  }, {
                    footer: _withCtx(() => [
                      _createVNode(_component_Button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.maximized = true)),
                        icon: "pi pi-pause",
                        class: "p-button-sm p-button-warning"
                      })
                    ]),
                    _: 1
                  }, 8, ["visible"]),
                  _createVNode(_component_Dialog, {
                    breakpoints: { '960px': '96vw' },
                    style: { maxWidth: '400px', 'margin-top': '-5px' },
                    position: "top",
                    visible: _ctx.maximized,
                    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.maximized) = $event)),
                    closable: true
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("h6", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(" [" + _toDisplayString(_ctx.activeTerminal.name) + "] Mode lecture seule ", 1)
                      ])
                    ]),
                    footer: _withCtx(() => [
                      _createVNode(_component_ProgressBar, {
                        style: {"height":"5px"},
                        mode: "indeterminate"
                      })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ], 64))
              : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}